import React, { FC } from 'react';
import i18n from 'i18n';
import styled from 'styled-components';

import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';
import { ModalImageContainerWithText } from '../../ImageContainer/ModalImageContainer';
import Typography from '../../Typography';

const ParentAppImageContainer = styled.div`
  display: flex;
  margin-top: 16px;
  align-self: flex-start;
`;

interface InstallTileModalProps extends ModalProps {}

export const InstallTileAndAppModal: FC<InstallTileModalProps> = ({ app, deviceName, onCancel, onSuccess, parentApp }) => (
  <Dialog
    show={true}
    id="InstallTileAndAppModal"
    title={i18n('component.InstallTileAndAppModal.title')({ appName: app.name })}
    onDismiss={onCancel}
    actions={[
      {
        text: i18n('component.InstallTileAndAppModal.cancelText')(),
        onClick: onCancel,
        variant: 'text',
        id: 'uninstall-button-cancel'
      },
      {
        text: i18n('component.InstallTileAndAppModal.continueText')(),
        onClick: onSuccess,
        variant: 'filled',
        id: 'install-button-ok'
      }
    ]}
  >
    <Typography variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
      {i18n('component.InstallTileAndAppModal.content')({ appName: app.name, tileName: app.name })}
    </Typography>
    {parentApp && (
      <ParentAppImageContainer>
        <ModalImageContainerWithText 
          app={parentApp}
          text={parentApp.name}
          subtext={parentApp.developer.name}
          deviceName={deviceName}
        />
      </ParentAppImageContainer>
    )}
  </Dialog>
);

export default InstallTileAndAppModal;
